Ext.define('SA.view.NullRegion', {
    getWidth() {
        return 0;
    },

    intersect() {
        return this;
    }
});

Ext.define('SA.view.Region', {
    statics: {
        create({top, left, right, bottom}) {
            return new SA.view.Region({top, left, right, bottom});
        },

        createNull() {
            return new SA.view.NullRegion();
        },

        forEl(el) {
            var {top, left, right, bottom} = el.getBoundingClientRect();

            return this.create({top, left, right, bottom});
        }
    },

    constructor({top, left, right, bottom}) {
        this.top = top;
        this.left = left;
        this.right = right;
        this.bottom = bottom;
    },

    adjustBy(amounts) {
        var top = this.getTop() + amounts.top,
            left = this.getLeft() + amounts.left,
            right = this.getRight() + amounts.right,
            bottom = this.getBottom() + amounts.bottom;

        return SA.view.Region.create({top, left, right, bottom});
    },

    getBottom() {
        return this.bottom;
    },

    getHeight() {
        return this.getBottom() - this.getTop();
    },

    getHorizontalCenter() {
        return this.getLeft() + (this.getWidth() / 2);
    },

    getLeft() {
        return this.left;
    },

    getRight() {
        return this.right;
    },

    getTop() {
        return this.top;
    },

    getWidth() {
        return this.getRight() - this.getLeft();
    },

    growBy(amount) {
        return this.adjustBy({top: -amount, left: -amount, right: amount, bottom: amount});
    },

    intersect(otherRegion) {
        if (!this.intersects(otherRegion)) {
            return SA.view.Region.createNull();
        }

        var top = Math.max(this.getTop(), otherRegion.getTop()),
            left = Math.max(this.getLeft(), otherRegion.getLeft()),
            right = Math.min(this.getRight(), otherRegion.getRight()),
            bottom = Math.min(this.getBottom(), otherRegion.getBottom());

        return SA.view.Region.create({top, left, right, bottom});
    },

    intersects(otherRegion) {
        return (this.getLeft() <= otherRegion.getRight()) && (this.getRight() >= otherRegion.getLeft())
            && (this.getTop() <= otherRegion.getBottom()) && (this.getBottom() >= otherRegion.getTop());
    }
});